import { createContext, useContext, useEffect, type ReactNode } from 'react';

// Jede Seite der Mandanten-App meldet Titel, Pfad (Breadcrumb) und Zurück-Ziel an die Kopfzeile.
export interface Crumb {
  label: string;
  to?: string; // ohne Ziel: nicht klickbar
}

export interface PageInfo {
  title: string;
  crumbs?: Crumb[];
  back?: string; // ohne back: erste Ebene, Logo statt „‹ Zurück“
  nav?: 'start' | 'belege' | 'dokumente' | 'mitarbeiter' | 'jahresabschluss' | 'nachrichten' | 'rechnungen';
}

const PageContext = createContext<(p: PageInfo) => void>(() => {});

export function PageProvider({ set, children }: { set(p: PageInfo): void; children: ReactNode }) {
  return <PageContext.Provider value={set}>{children}</PageContext.Provider>;
}

export function usePage(p: PageInfo) {
  const set = useContext(PageContext);
  const key = JSON.stringify(p);
  useEffect(() => {
    set(p);
    document.title = p.title === 'Elbcons' ? 'Elbcons' : `${p.title} · Elbcons`;
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [key, set]);
}
